import { systemColors } from "../system";

const base = {
  DEFAULT: systemColors["sys-outline"].dark,
  strong: systemColors["sys-black"].DEFAULT,
  muted: systemColors["sys-grey"][200],
  elevated: systemColors["sys-neutral"][500],
};


const functional = {
  subtle: systemColors["sys-neutral"][500],
  info: systemColors["sys-lavender"][300],
  success: systemColors["sys-olive"][300],
  reassurance: systemColors["sys-blue"][600],
  destructive: systemColors["sys-coral"][300],
  warning: systemColors["sys-marmalade"][300],
  price: systemColors["sys-pink"][600],
  benefit: systemColors["sys-green"][300],
  elevated: systemColors["sys-neutral"][300],
};

const state = {
  focus: systemColors["sys-chartreuse"][600],
  "focus-offset": systemColors["sys-chartreuse"][50],
};

const outline = {
  dark: systemColors["sys-outline"].dark,
  light: systemColors["sys-outline"].light,
};

const button = {
  default: systemColors["sys-black"].DEFAULT,
  secondary: systemColors["sys-chartreuse"][600],
  tertiary: systemColors["sys-black"].DEFAULT,
};

const badge = {
  default: systemColors["sys-black"].DEFAULT,
  secondary: systemColors["sys-chartreuse"][600],
  outline: base.strong,
  price: functional.price,
};

const tag = {
  discount: systemColors["sys-green"][600],
};

const pill = {
  default: systemColors["sys-white"],
  price: functional.price,
  benefit: functional.benefit,
  warning: functional.warning,
  destructive: functional.destructive,
};

const input = {
  default: base.strong,
  destructive: functional.destructive,
};

const checkbox = {
  check: {
    checked: systemColors["sys-black"][850],
    unchecked: systemColors["sys-grey"][500],
  },
  variant: {
    boxed: {
      checked: systemColors["sys-black"][850],
      unchecked: systemColors["sys-grey"][500],
    },
  },
};

const radio = {
  variant: {
    boxed: {
      checked: base.strong,
    },
  },
};

const dialog = {
  DEFAULT: systemColors["sys-black"].DEFAULT,
};

const collapsable = {
  trigger: {
    variant: {
      secondary: base.strong,
    },
  },
  content: {
    variant: {
      secondary: base.strong,
    },
  },
};

const navigationMenu = {
  viewport: systemColors["sys-grey"][200],
};

const responsiveNavigation = systemColors["sys-grey"][200];

const card = {
  base: systemColors["sys-black"].DEFAULT,
};

const headedSection = {
  base: systemColors["sys-black"].DEFAULT,
};

const alert = {
  subtle: functional.subtle,
  info: functional.info,
  reassurace: systemColors["sys-blue"][600],
  success: systemColors["sys-olive"][800],
  destructive: systemColors["sys-coral"][800],
  fyi: systemColors["sys-neutral"][300],
};

const component = {
  alert,
  badge,
  tag,
  button,
  pill,
  checkbox,
  input,
  dialog,
  collapsable,
  radio,
  navigationMenu,
  "responsive-navigation": responsiveNavigation,
  card,
  "headed-section": headedSection,
};



export const borderColor = {
  ...base,
  component,
  functional,
  state,
  outline,
};
